var map = {
	"./1/cover.jpg": "1fjZ",
	"./10/cover.jpg": "9Rhe",
	"./11/cover.jpg": "ARso",
	"./12/cover.jpg": "Iswf",
	"./2/cover.jpg": "VKI3",
	"./3/cover.jpg": "VkFM",
	"./4/cover.jpg": "VHRS",
	"./5/cover.jpg": "BD5z",
	"./6/cover.jpg": "r4gZ",
	"./7/cover.jpg": "PgHz",
	"./8/cover.jpg": "eJ0X",
	"./9/cover.jpg": "8d1n"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IDov";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3 ^\.\/.*\/cover\.jpg$
// module id = IDov
// module chunks = 39